import { Injectable, inject } from '@angular/core';
import { ApiService } from '@core/services/api.service';
import { BussinesService } from '../../public/services';
import { Workplace } from '../models/workplace.model';
import { MatDialog } from '@angular/material/dialog';
import { Cookies } from 'typescript-cookie';

@Injectable({
  providedIn: 'root',
})
export class WorkplaceService {
  private apiService = inject(ApiService);
  private workplaceService = inject(BussinesService);
  private dialog = inject(MatDialog);

  getkorkplace(id: number) {
    return this.apiService.getAll(`workplace?floorid=${id}`);
  }

  storeworkplace(data: Workplace) {
    let Subbody = {
      name: data.name,
      description: data.description,
      phone: data.phone,
      x: data.x,
      y: data.y,
      status: data.status,
      workplacetypeid: data.workplacetypeid,
      floorid: data.floorid,
      roleid: data.roleid,
      workplacegroupid: data.workplacegroupid,
      monday: data.monday,
      tuesday: data.tuesday,
      wednesday: data.wednesday,
      thursday: data.thursday,
      friday: data.friday,
      saturday: data.saturday,
      sunday: data.sunday,
      assignedWorker: data.assignedWorker,
      startDate: data.startDate,
      endDate: data.endDate,
    };

    if (data.assignedWorker == null) {
      delete Subbody.assignedWorker;
    }
    if (data.startDate == null) {
      delete Subbody.startDate;
    }
    if (data.endDate == null) {
      delete Subbody.endDate;
    }

    const body = { workplaces: [Subbody] };

    console.log('Envio de datos: ', JSON.stringify(body));
    return this.apiService.store(
      'workplace?workplaces=' + encodeURIComponent(JSON.stringify(body)),
      {}
    );
  }

  deleteWorkplace(id: number) {
    return this.apiService.delete('workplace', id);
  }

  updateJob(id: number, data: any) {
    let cadena = `workplace/${id}?name=${data.name}&description=${data.description}&phone=${data.phone}&x=${data.x}&y=${data.y}&status=${data.status}&workplacetypeid=${data.workplacetypeid}&floorid=${data.floorid}&workplaceGroupId=${data.workplaceGroupId}&monday=${data.monday}&tuesday=${data.tuesday}&wednesday=${data.wednesday}&thursday=${data.thursday}&friday=${data.friday}&saturday=${data.saturday}&sunday=${data.sunday}`;
    if (data.assignedWorker) {
      cadena = cadena + `&assignedWorker=${data.assignedWorker}`;
    }
    if (data.startDate) {
      cadena = cadena + `&startDate=${data.startDate}`;
    }
    if (data.endDate) {
      cadena = cadena + `&endDate=${data.endDate}`;
    }
    return this.apiService.update(cadena, undefined, id);
  }

  availablePositions(
    workerid: number,
    floor: number,
    startDate: string,
    endDate: string,
    type: number
  ) {
    const business = Cookies.get('bussinesId');
    return this.apiService.get(
      `workplace/availablePositions?floorid=${floor}&typeId=${type}&startDate=${startDate}&endDate=${endDate}&business_id=${business}&workerId=${workerid}`
    );
  }
}
